var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-container details"},[_c('div',{staticClass:"headerTitle"},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.message.newsTitle))]),_c('p',{staticClass:"date"},[_vm._v("发布时间: "+_vm._s(_vm.message.pubDtm))])]),_c('div',{staticClass:"content-data",domProps:{"innerHTML":_vm._s(_vm.message.newsContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }